import {DoctorActionTypes} from '../actions/doctor.actions';
import {Patient} from '../../model/user/Patient';
import {
  QuestionnaireEORTCResult,
  QuestionnaireEQ5D5LResult,
  QuestionnaireHBIResult, QuestionnaireIBDDiskResult, QuestionnaireSIBDQResult, QuestionnaireTSQMResult, QuestionnaireWPAIResult,
  QuestionnaireIBDQResult,QuestionnaireLARSResult
} from '../../model/questionnaires/questionnaire-results';
import {JobModel} from '../../model/job/JobModel';


export interface State {
  patients: Patient[] | null;
  resultsEORTC: QuestionnaireEORTCResult[] | null;
  resultsEQ5D5L: QuestionnaireEQ5D5LResult[] | null;
  resultsHBI: QuestionnaireHBIResult[] | null;
  resultsIBDDisk: QuestionnaireIBDDiskResult[] | null;
  resultsSIBDQ: QuestionnaireSIBDQResult[] | null;
  resultsTSQM: QuestionnaireTSQMResult[] | null;
  resultsWPAI: QuestionnaireWPAIResult[] | null;
  resultsIBDQ: QuestionnaireIBDQResult[] | null;
  resultsLARS: QuestionnaireLARSResult[] | null;
  errorMessage: string | null;
  jobs: JobModel[] | null;
}

export const initialState: State = {
  patients: null,
  resultsEORTC: null,
  resultsEQ5D5L: null,
  resultsHBI: null,
  resultsIBDDisk: null,
  resultsSIBDQ: null,
  resultsTSQM: null,
  resultsWPAI: null,
  errorMessage: null,
  resultsIBDQ: null,
  resultsLARS: null,
  jobs: null
};

export function doctorReducer(state = initialState, action): State {
  switch (action.type) {
    case DoctorActionTypes.GET_PATIENTS: {
      return {
        ...state,
        patients: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_PATIENTS_SUCCESS: {
      return {
        ...state,
        patients: action.payload.patients,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_PATIENTS_FAILURE: {
      return {
        ...state,
        patients: null,
        errorMessage: '[Doctor] Get patients failed'
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_EORTC: {
      return {
        ...state,
        resultsEORTC: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_EORTC_SUCCESS: {
      return {
        ...state,
        resultsEORTC: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_EORTC_FAILURE: {
      return {
        ...state,
        resultsEORTC: null,
        errorMessage: '[Doctor] Get EORTC failed'
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L: {
      return {
        ...state,
        resultsEQ5D5L: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L_SUCCESS: {
      return {
        ...state,
        resultsEQ5D5L: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L_FAILURE: {
      return {
        ...state,
        resultsEQ5D5L: null,
        errorMessage: '[Doctor] Get EQ5D5L failed'
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_HBI: {
      return {
        ...state,
        resultsHBI: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_HBI_SUCCESS: {
      return {
        ...state,
        resultsHBI: action.payload.resultsHBI,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_HBI_FAILURE: {
      return {
        ...state,
        resultsHBI: null,
        errorMessage: '[Doctor] Get HBI failed'
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK: {
      return {
        ...state,
        resultsIBDDisk: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK_SUCCESS: {
      return {
        ...state,
        resultsIBDDisk: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK_FAILURE: {
      return {
        ...state,
        resultsIBDDisk: null,
        errorMessage: '[Doctor] Get IBD-Disk failed'
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ: {
      return {
        ...state,
        resultsSIBDQ: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ_SUCCESS: {
      return {
        ...state,
        resultsSIBDQ: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ_FAILURE: {
      return {
        ...state,
        resultsSIBDQ: null,
        errorMessage: '[Doctor] Get SIBDQ failed'
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ: {
      return {
        ...state,
        resultsIBDQ: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ_SUCCESS: {
      return {
        ...state,
        resultsIBDQ: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ_FAILURE: {
      return {
        ...state,
        resultsIBDQ: null,
        errorMessage: '[Doctor] Get IBDQ failed'
      };
    }





    case DoctorActionTypes.GET_QUESTIONNAIRES_LARS: {
      return {
        ...state,
        resultsLARS: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_LARS_SUCCESS: {
      return {
        ...state,
        resultsLARS: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_LARS_FAILURE: {
      return {
        ...state,
        resultsLARS: null,
        errorMessage: '[Doctor] Get LARS failed'
      };
    }





    case DoctorActionTypes.GET_QUESTIONNAIRES_TSQM: {
      return {
        ...state,
        resultsTSQM: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_TSQM_SUCCESS: {
      return {
        ...state,
        resultsTSQM: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_TSQM_FAILURE: {
      return {
        ...state,
        resultsTSQM: null,
        errorMessage: '[Doctor] Get TSQM failed'
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_WPAI: {
      return {
        ...state,
        resultsWPAI: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_WPAI_SUCCESS: {
      return {
        ...state,
        resultsWPAI: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_QUESTIONNAIRES_WPAI_FAILURE: {
      return {
        ...state,
        resultsWPAI: null,
        errorMessage: '[Doctor] Get WPAI failed'
      };
    }

    case DoctorActionTypes.GET_JOBS: {
      return {
        ...state,
        jobs: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_JOBS_SUCCESS: {
      return {
        ...state,
        jobs: action.payload,
        errorMessage: null
      };
    }

    case DoctorActionTypes.GET_JOBS_FAILURE: {
      return {
        ...state,
        jobs: null,
        errorMessage: '[Doctor] Get jobs for patient failed'
      };
    }

    default: {
      return state;
    }
  }
}
